// TPP Core: content behaviour (page / blog / article templates). Presentation only; no copy is added.
// - Articles: a thin lime reading-progress line at the top of the viewport (scroll-linked, no library).
(function () {
  if (window.__tppContent) return;
  window.__tppContent = true;

  const body = document.body;
  if (!body || !body.classList.contains('template-article')) return;
  const article = document.querySelector('.article-page .article .rte, #bloggle_rte');
  if (!article) return;

  const bar = document.createElement('div');
  bar.className = 'tpp-read-progress';
  bar.setAttribute('aria-hidden', 'true');
  body.appendChild(bar);

  let ticking = false;
  function update() {
    ticking = false;
    const r = article.getBoundingClientRect();
    const total = r.height - window.innerHeight * 0.6;
    const done = Math.min(1, Math.max(0, (-r.top + window.innerHeight * 0.2) / (total > 0 ? total : 1)));
    bar.style.transform = 'scaleX(' + done.toFixed(4) + ')';
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
